export const colorsDataXML = `<?xml version="1.0" encoding="UTF-8"?>
<colors>
    <color id="224">
        <techname>ECO-PLUS</techname>
        <name>Eco +</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="29">
        <techname>DRK-R</techname>
        <name>Bouton rouge</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>C70007</hexacolor>
        <texturepng>/kewapp/textures/125.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/125.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/125.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="31">
        <techname>DRK-BL</techname>
        <name>Bouton bleu</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>1E46AD</hexacolor>
        <texturepng>/kewapp/textures/121.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/121.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/121.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="32">
        <techname>DRK-BR</techname>
        <name>Bouton brun</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>6F4B12</hexacolor>
        <texturepng>/kewapp/textures/120.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/120.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/120.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="35">
        <techname>DRK-J</techname>
        <name>Bouton jaune</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>FFDF3F</hexacolor>
        <texturepng>/kewapp/textures/119.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/119.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/119.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="37">
        <techname>DRK-N</techname>
        <name>Bouton noir</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>060501</hexacolor>
        <texturepng>/kewapp/textures/126.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/126.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/126.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="38">
        <techname>DRK-V</techname>
        <name>Bouton vert</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>379044</hexacolor>
        <texturepng>/kewapp/textures/124.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/124.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/124.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="49">
        <techname>BRUT</techname>
        <name>Naturel</name>
        <category>Plateau simple</category>
        <typecolor>plate</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="50">
        <techname>W4006</techname>
        <name>Blanc</name>
        <category>Plateau simple</category>
        <typecolor>plate</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/22.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/22.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/22.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="51">
        <techname>U4020</techname>
        <name>Noir</name>
        <category>Plateau simple</category>
        <typecolor>plate</typecolor>
        <hexacolor>242623</hexacolor>
        <texturepng>/kewapp/textures/23.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/23.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/23.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="52">
        <techname>3T17</techname>
        <name>Mandarine</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>db5c0b</hexacolor>
        <texturepng>/kewapp/textures/1.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/1.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/1.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="53">
        <techname>6T21</techname>
        <name>Glacier</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>CAE5C6</hexacolor>
        <texturepng>/kewapp/textures/2.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/2.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/2.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="54">
        <techname>000</techname>
        <name>Transparent</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>F4F0EB</hexacolor>
        <texturepng>/kewapp/textures/3.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/3.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/3.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="56">
        <techname>7T28</techname>
        <name>Saphir</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>0A1F8C</hexacolor>
        <texturepng>/kewapp/textures/5.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/5.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/5.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="58">
        <techname>4T50</techname>
        <name>Chili</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>E91A24</hexacolor>
        <texturepng>/kewapp/textures/7.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/7.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/7.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="59">
        <techname>7T69</techname>
        <name>Ciel</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>6493C2</hexacolor>
        <texturepng>/kewapp/textures/8.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/8.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/8.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="61">
        <techname>7T77</techname>
        <name>Arctic</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>71ABB7</hexacolor>
        <texturepng>/kewapp/textures/10.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/10.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/10.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="62">
        <techname>2T30</techname>
        <name>Sorbet</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>DDDC88</hexacolor>
        <texturepng>/kewapp/textures/11.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/11.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/11.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="64">
        <techname>030</techname>
        <name>Polaire</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>EBEBEB</hexacolor>
        <texturepng>/kewapp/textures/13.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/13.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/13.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="65">
        <techname>7T1D</techname>
        <name>Eau</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>069CCE</hexacolor>
        <texturepng>/kewapp/textures/14.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/14.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/14.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="66">
        <techname>6T91</techname>
        <name>Citron Vert</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>C2D958</hexacolor>
        <texturepng>/kewapp/textures/15.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/15.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/15.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="67">
        <techname>6T93</techname>
        <name>Turquoise</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>5DC1A5</hexacolor>
        <texturepng>/kewapp/textures/16.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/16.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/16.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="68">
        <techname>4T85</techname>
        <name>Cyclamen</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>DB4D99</hexacolor>
        <texturepng>/kewapp/textures/17.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/17.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/17.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="69">
        <techname>2T41</techname>
        <name>Orange</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>FEA000</hexacolor>
        <texturepng>/kewapp/textures/18.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/18.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/18.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="70">
        <techname>9T21</techname>
        <name>Anthracite</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>545451</hexacolor>
        <texturepng>/kewapp/textures/19.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/19.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/19.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="71">
        <techname>6T92</techname>
        <name>Pomme</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>79DD11</hexacolor>
        <texturepng>/kewapp/textures/20.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/20.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/20.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="76">
        <techname>BRUT-ECO</techname>
        <name>Eco</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="77">
        <techname>BRUT</techname>
        <name>Naturel</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="78">
        <techname>U4020</techname>
        <name>Noir</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>242623</hexacolor>
        <texturepng>/kewapp/textures/23.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/23.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/23.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="79">
        <techname>W4006</techname>
        <name>Blanc</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/22.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/22.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/22.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="80">
        <techname>ALU</techname>
        <name>Alu</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>99A099</hexacolor>
        <texturepng>/kewapp/textures/114.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/114.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/114.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="85">
        <techname>G1</techname>
        <name>Traverse frontale rainuree (G1)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/153.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/153.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/153.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="93">
        <techname>CB</techname>
        <name>Coupelle blanche</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>FFFFF5</hexacolor>
        <texturepng>/kewapp/textures/147.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/147.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/147.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="87">
        <techname>G2</techname>
        <name>Traverse frontale non rainurée (G2)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/155.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/155.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/155.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="88">
        <techname>G1R</techname>
        <name>Traverse frontale rainurée renforcée (G1R)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/154.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/154.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/154.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="89">
        <techname>G2R</techname>
        <name>Traverse frontale non rainurée renforcée (G2R)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/156.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/156.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/156.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="90">
        <techname>F1</techname>
        <name>Traverse dorsale ou latérale rainurée (F1)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/151.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/151.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/151.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="91">
        <techname>F2</techname>
        <name>Traverse dorsale ou latérale non rainurée (F2)</name>
        <category>Traverses</category>
        <typecolor>tra</typecolor>
        <hexacolor>F1BE00</hexacolor>
        <texturepng>/kewapp/textures/152.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/152.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/152.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="94">
        <techname>CR</techname>
        <name>Coupelle rouge</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>C70007</hexacolor>
        <texturepng>/kewapp/textures/139.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/139.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/139.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="131">
        <techname>5T18</techname>
        <name>Cappuccino</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>7C653A</hexacolor>
        <texturepng>/kewapp/textures/87.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/87.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/87.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="136">
        <techname>010</techname>
        <name>Crystal</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>F2F0EF</hexacolor>
        <texturepng>/kewapp/textures/111.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/111.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/111.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="140">
        <techname>4T97</techname>
        <name>Framboise</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>D74652</hexacolor>
        <texturepng>/kewapp/textures/85.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/85.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/85.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="143">
        <techname>2T53</techname>
        <name>Mimosa</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>FFD24E</hexacolor>
        <texturepng>/kewapp/textures/92.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/92.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/92.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="145">
        <techname>7TIF</techname>
        <name>Lagon</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>539D9B</hexacolor>
        <texturepng>/kewapp/textures/88.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/88.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/88.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="150">
        <techname>9221</techname>
        <name>Noir Mat</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>222121</hexacolor>
        <texturepng>/kewapp/textures/89.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/89.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/89.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="152">
        <techname>6T9A</techname>
        <name>Olive</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>9A9F38</hexacolor>
        <texturepng>/kewapp/textures/91.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/91.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/91.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="157">
        <techname>8T15</techname>
        <name>Prune</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>75225D</hexacolor>
        <texturepng>/kewapp/textures/86.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/86.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/86.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="171">
        <techname>G</techname>
        <name>Galvanisées</name>
        <category>Cornière</category>
        <typecolor>corn</typecolor>
        <hexacolor>666666</hexacolor>
        <texturepng>/kewapp/textures/113.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/113.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/113.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="172">
        <techname>I</techname>
        <name>Inox</name>
        <category>Cornière</category>
        <typecolor>corn</typecolor>
        <hexacolor>999999</hexacolor>
        <texturepng>/kewapp/textures/99.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/99.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/99.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="173">
        <techname>N</techname>
        <name>Noires</name>
        <category>Cornière</category>
        <typecolor>corn</typecolor>
        <hexacolor>000000</hexacolor>
        <texturepng>/kewapp/textures/23.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/23.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/23.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="174">
        <techname>B</techname>
        <name>Blanches</name>
        <category>Cornière</category>
        <typecolor>corn</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/22.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/22.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/22.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="175">
        <techname>CV</techname>
        <name>Coupelle verte</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>379044</hexacolor>
        <texturepng>/kewapp/textures/138.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/138.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/138.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="176">
        <techname>CBL</techname>
        <name>Coupelle bleue</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>1E46AD</hexacolor>
        <texturepng>/kewapp/textures/146.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/146.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/146.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="177">
        <techname>CBR</techname>
        <name>Coupelle brune</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>6F4B12</hexacolor>
        <texturepng>/kewapp/textures/145.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/145.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/145.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="178">
        <techname>CC</techname>
        <name>Coupelle crème</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>F7F6BF</hexacolor>
        <texturepng>/kewapp/textures/144.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/144.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/144.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="179">
        <techname>CG</techname>
        <name>Coupelle grise</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>D4D4D4</hexacolor>
        <texturepng>/kewapp/textures/143.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/143.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/143.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="180">
        <techname>CJ</techname>
        <name>Coupelle jaune</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>FFDF3F</hexacolor>
        <texturepng>/kewapp/textures/142.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/142.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/142.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="182">
        <techname>CN</techname>
        <name>Coupelle noire</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>060501</hexacolor>
        <texturepng>/kewapp/textures/140.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/140.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/140.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="185">
        <techname>CGS</techname>
        <name>Coupelle gris souris</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>808080</hexacolor>
        <texturepng>/kewapp/textures/148.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/148.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/148.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="194">
        <techname>CGA</techname>
        <name>Coupelle galva</name>
        <category>Coupelle</category>
        <typecolor>knob</typecolor>
        <hexacolor>666666</hexacolor>
        <texturepng>/kewapp/textures/158.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/158.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/158.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="196">
        <techname>TA</techname>
        <name>Latte en bois</name>
        <category>Options penderies</category>
        <typecolor>slat</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/161.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/161.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/161.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="197">
        <techname>TE</techname>
        <name>Latte en aluminium</name>
        <category>Options penderies</category>
        <typecolor>slat</typecolor>
        <hexacolor>99A099</hexacolor>
        <texturepng>/kewapp/textures/160.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/160.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/160.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="207">
        <techname>4T46</techname>
        <name>Rose Blush</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>E0AEA6</hexacolor>
        <texturepng>/kewapp/textures/164.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/164.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/164.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="40">
        <techname>DRP-B</techname>
        <name>Poignée blanche</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>FFFFF5</hexacolor>
        <texturepng>/kewapp/textures/136.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/136.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/136.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="43">
        <techname>DRP-C</techname>
        <name>Poignée crème</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>F7F6BF</hexacolor>
        <texturepng>/kewapp/textures/137.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/137.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/137.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="44">
        <techname>DRP-G</techname>
        <name>Poignée grise</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>DDDDC2</hexacolor>
        <texturepng>/kewapp/textures/135.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/135.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/135.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="188">
        <techname>DRP-S</techname>
        <name>Poignée gris souris</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>808080</hexacolor>
        <texturepng>/kewapp/textures/129.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/129.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/129.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="47">
        <techname>DRP-N</techname>
        <name>Poignée noire</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>060501</hexacolor>
        <texturepng>/kewapp/textures/131.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/131.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/131.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="48">
        <techname>DRP-V</techname>
        <name>Poignée verte</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>379044</hexacolor>
        <texturepng>/kewapp/textures/133.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/133.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/133.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="45">
        <techname>DRP-J</techname>
        <name>Poignée jaune</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>FFDF3F</hexacolor>
        <texturepng>/kewapp/textures/130.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/130.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/130.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="209">
        <techname>DRL-BH</techname>
        <name>Poignée en bois</name>
        <category>Lattes</category>
        <typecolor>slat_d</typecolor>
        <hexacolor>E1BD7F</hexacolor>
        <texturepng>/kewapp/textures/194.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/194.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/194.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="41">
        <techname>DRP-BL</techname>
        <name>Poignée bleu</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>1E46AD</hexacolor>
        <texturepng>/kewapp/textures/127.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/127.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/127.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="42">
        <techname>DRP-BR</techname>
        <name>Poignée brune</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>6F4B12</hexacolor>
        <texturepng>/kewapp/textures/128.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/128.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/128.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="190">
        <techname>DRP-AC</techname>
        <name>Poignée chromée</name>
        <category>Poignées</category>
        <typecolor>pull</typecolor>
        <hexacolor>9d9d9d</hexacolor>
        <texturepng>/kewapp/textures/115.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/115.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/115.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="30">
        <techname>DRK-B</techname>
        <name>Bouton blanc</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>FFFFF5</hexacolor>
        <texturepng>/kewapp/textures/122.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/122.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/122.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="33">
        <techname>DRK-C</techname>
        <name>Bouton crème</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>F7F6BF</hexacolor>
        <texturepng>/kewapp/textures/117.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/117.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/117.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="183">
        <techname>DRK-AF</techname>
        <name>Bouton Alu (fin)</name>
        <category>Boutons</category>
        <typecolor>knob</typecolor>
        <hexacolor>949494</hexacolor>
        <texturepng>/kewapp/textures/149.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/149.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/149.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="184">
        <techname>DRK-AG</techname>
        <name>Bouton Alu (large)</name>
        <category>Boutons</category>
        <typecolor>knob</typecolor>
        <hexacolor>949494</hexacolor>
        <texturepng>/kewapp/textures/150.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/150.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/150.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="34">
        <techname>DRK-G</techname>
        <name>Bouton gris</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>DDDDC2</hexacolor>
        <texturepng>/kewapp/textures/118.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/118.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/118.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="189">
        <techname>DRK-S</techname>
        <name>Bouton gris souris</name>
        <category>Boutons</category>
        <typecolor>button</typecolor>
        <hexacolor>808080</hexacolor>
        <texturepng>/kewapp/textures/123.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/123.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/123.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="21">
        <techname>BRUT</techname>
        <name>Naturel</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="97">
        <techname>BRUT</techname>
        <name>Naturel</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="98">
        <techname>BRUT</techname>
        <name>Naturel</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>938761</hexacolor>
        <texturepng>/kewapp/textures/21.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/21.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/21.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="22">
        <techname>W4006</techname>
        <name>Blanc</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/22.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/22.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/22.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="95">
        <techname>W4006</techname>
        <name>Blanc</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/22.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/22.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/22.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="118">
        <techname>H5474</techname>
        <name>Hêtre Cérusé</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>EFEDE3</hexacolor>
        <texturepng>/kewapp/textures/98.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/98.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/98.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="164">
        <techname>H5474</techname>
        <name>Hêtre Cérusé</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>EFEDE3</hexacolor>
        <texturepng>/kewapp/textures/98.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/98.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/98.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="210">
        <techname>H5474</techname>
        <name>Hêtre Cérusé</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>EFEDE3</hexacolor>
        <texturepng>/kewapp/textures/98.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/98.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/98.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="24">
        <techname>U4024</techname>
        <name>Gris clair</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>B8B8B0</hexacolor>
        <texturepng>/kewapp/textures/24.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/24.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/24.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="162">
        <techname>U4024</techname>
        <name>Gris clair</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>B8B8B0</hexacolor>
        <texturepng>/kewapp/textures/24.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/24.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/24.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="225">
        <techname>U4024</techname>
        <name>Gris clair</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>B8B8B0</hexacolor>
        <texturepng>/kewapp/textures/24.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/24.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/24.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="84">
        <techname>U4008</techname>
        <name>Gris Souris</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>616161</hexacolor>
        <texturepng>/kewapp/textures/84.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/84.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/84.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="163">
        <techname>U4008</techname>
        <name>Gris Souris</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>616161</hexacolor>
        <texturepng>/kewapp/textures/84.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/84.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/84.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="215">
        <techname>U4008</techname>
        <name>Gris Souris</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>616161</hexacolor>
        <texturepng>/kewapp/textures/84.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/84.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/84.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="23">
        <techname>U4020</techname>
        <name>Noir</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>242623</hexacolor>
        <texturepng>/kewapp/textures/23.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/23.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/23.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="100">
        <techname>U4020</techname>
        <name>Noir</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>242623</hexacolor>
        <texturepng>/kewapp/textures/23.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/23.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/23.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="25">
        <techname>U4017</techname>
        <name>Bleu</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>1A1D77</hexacolor>
        <texturepng>/kewapp/textures/25.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/25.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/25.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="120">
        <techname>U4017</techname>
        <name>Bleu</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>1A1D77</hexacolor>
        <texturepng>/kewapp/textures/25.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/25.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/25.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="211">
        <techname>U4017</techname>
        <name>Bleu</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>1A1D77</hexacolor>
        <texturepng>/kewapp/textures/25.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/25.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/25.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="115">
        <techname>U532</techname>
        <name>Pétrole</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>005B71</hexacolor>
        <texturepng>/kewapp/textures/94.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/94.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/94.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="168">
        <techname>U532</techname>
        <name>Pétrole</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>005B71</hexacolor>
        <texturepng>/kewapp/textures/94.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/94.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/94.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="220">
        <techname>U532</techname>
        <name>Pétrole</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>005B71</hexacolor>
        <texturepng>/kewapp/textures/94.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/94.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/94.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="114">
        <techname>U535</techname>
        <name>Bleu Clair</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>B4DEE7</hexacolor>
        <texturepng>/kewapp/textures/93.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/93.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/93.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="121">
        <techname>U535</techname>
        <name>Bleu Clair</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>B4DEE7</hexacolor>
        <texturepng>/kewapp/textures/93.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/93.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/93.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="219">
        <techname>U535</techname>
        <name>Bleu Clair</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>B4DEE7</hexacolor>
        <texturepng>/kewapp/textures/93.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/93.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/93.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="222">
        <techname>U535</techname>
        <name>Bleu Clair</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>B4DEE7</hexacolor>
        <texturepng>/kewapp/textures/93.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/93.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/93.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="83">
        <techname>U4018</techname>
        <name>Crème</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FCEEC1</hexacolor>
        <texturepng>/kewapp/textures/83.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/83.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/83.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="122">
        <techname>U4018</techname>
        <name>Crème</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FCEEC1</hexacolor>
        <texturepng>/kewapp/textures/83.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/83.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/83.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="200">
        <techname>U4018</techname>
        <name>Crème</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FCEEC1</hexacolor>
        <texturepng>/kewapp/textures/83.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/83.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/83.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="214">
        <techname>U4018</techname>
        <name>Crème</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>FCEEC1</hexacolor>
        <texturepng>/kewapp/textures/83.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/83.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/83.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="112">
        <techname>U730</techname>
        <name>Taupe</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>958880</hexacolor>
        <texturepng>/kewapp/textures/95.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/95.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/95.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="169">
        <techname>U730</techname>
        <name>Taupe</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>958880</hexacolor>
        <texturepng>/kewapp/textures/95.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/95.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/95.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="217">
        <techname>U730</techname>
        <name>Taupe</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>958880</hexacolor>
        <texturepng>/kewapp/textures/95.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/95.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/95.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="113">
        <techname>U635</techname>
        <name>Tilleul</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>79987E</hexacolor>
        <texturepng>/kewapp/textures/97.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/97.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/97.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="167">
        <techname>U635</techname>
        <name>Tilleul</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>79987E</hexacolor>
        <texturepng>/kewapp/textures/97.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/97.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/97.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="218">
        <techname>U635</techname>
        <name>Tilleul</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>79987E</hexacolor>
        <texturepng>/kewapp/textures/97.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/97.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/97.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="116">
        <techname>U330</techname>
        <name>Aubergine</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>604150</hexacolor>
        <texturepng>/kewapp/textures/96.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/96.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/96.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="119">
        <techname>U330</techname>
        <name>Aubergine</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>604150</hexacolor>
        <texturepng>/kewapp/textures/96.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/96.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/96.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="221">
        <techname>U330</techname>
        <name>Aubergine</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>604150</hexacolor>
        <texturepng>/kewapp/textures/96.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/96.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/96.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="28">
        <techname>U4012</techname>
        <name>Rouge</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>F21D23</hexacolor>
        <texturepng>/kewapp/textures/28.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/28.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/28.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="102">
        <techname>U4012</techname>
        <name>Rouge</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>F21D23</hexacolor>
        <texturepng>/kewapp/textures/28.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/28.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/28.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="199">
        <techname>U4012</techname>
        <name>Rouge</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>F21D23</hexacolor>
        <texturepng>/kewapp/textures/28.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/28.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/28.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="213">
        <techname>U4012</techname>
        <name>Rouge</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>F21D23</hexacolor>
        <texturepng>/kewapp/textures/28.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/28.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/28.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="216">
        <techname>U4012</techname>
        <name>Rouge</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>F21D23</hexacolor>
        <texturepng>/kewapp/textures/28.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/28.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/28.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="204">
        <techname>U4004</techname>
        <name>Tangerine</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>E05502</hexacolor>
        <texturepng>/kewapp/textures/162.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/162.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/162.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="203">
        <techname>U4004</techname>
        <name>Tangerine</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>E05502</hexacolor>
        <texturepng>/kewapp/textures/162.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/162.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/162.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="223">
        <techname>U4004</techname>
        <name>Tangerine</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>E05502</hexacolor>
        <texturepng>/kewapp/textures/162.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/162.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/162.jpg</texturepixel>
        <opacity>1</opacity>
    </color>
    <color id="26">
        <techname>U4006</techname>
        <name>Jaune</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FBD008</hexacolor>
        <texturepng>/kewapp/textures/26.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/26.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/26.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="165">
        <techname>U4006</techname>
        <name>Jaune</name>
        <category>MDF</category>
        <typecolor>pane</typecolor>
        <hexacolor>FBD008</hexacolor>
        <texturepng>/kewapp/textures/26.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/26.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/26.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="212">
        <techname>U4006</techname>
        <name>Jaune</name>
        <category>Façade de tiroir</category>
        <typecolor>drawer</typecolor>
        <hexacolor>FBD008</hexacolor>
        <texturepng>/kewapp/textures/26.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/26.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/26.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="3">
        <techname>000</techname>
        <name>Transparent</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>F4F0EB</hexacolor>
        <texturepng>/kewapp/textures/3.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/3.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/3.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="134">
        <techname>000</techname>
        <name>Transparent</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>F4F0EB</hexacolor>
        <texturepng>/kewapp/textures/3.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/3.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/3.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="111">
        <techname>010</techname>
        <name>Crystal</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>F2F0EF</hexacolor>
        <texturepng>/kewapp/textures/111.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/111.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/111.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="135">
        <techname>010</techname>
        <name>Crystal</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>F2F0EF</hexacolor>
        <texturepng>/kewapp/textures/111.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/111.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/111.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="13">
        <techname>030</techname>
        <name>Polaire</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>EBEBEB</hexacolor>
        <texturepng>/kewapp/textures/13.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/13.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/13.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="155">
        <techname>030</techname>
        <name>Polaire</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>EBEBEB</hexacolor>
        <texturepng>/kewapp/textures/13.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/13.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/13.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="128">
        <techname>1T41</techname>
        <name>Blanc Mat</name>
        <category>Acrylique opaque</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/90.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/90.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/90.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="107">
        <techname>5T18</techname>
        <name>Cappuccino</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>7C653A</hexacolor>
        <texturepng>/kewapp/textures/87.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/87.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/87.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="130">
        <techname>5T18</techname>
        <name>Cappuccino</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>7C653A</hexacolor>
        <texturepng>/kewapp/textures/87.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/87.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/87.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="19">
        <techname>9T21</techname>
        <name>Anthracite</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>545451</hexacolor>
        <texturepng>/kewapp/textures/19.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/19.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/19.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="124">
        <techname>9T21</techname>
        <name>Anthracite</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>545451</hexacolor>
        <texturepng>/kewapp/textures/19.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/19.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/19.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="5">
        <techname>7T28</techname>
        <name>Saphir</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>0A1F8C</hexacolor>
        <texturepng>/kewapp/textures/5.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/5.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/5.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="158">
        <techname>7T28</techname>
        <name>Saphir</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>0A1F8C</hexacolor>
        <texturepng>/kewapp/textures/5.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/5.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/5.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="2">
        <techname>6T21</techname>
        <name>Glacier</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>CAE5C6</hexacolor>
        <texturepng>/kewapp/textures/2.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/2.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/2.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="141">
        <techname>6T21</techname>
        <name>Glacier</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>CAE5C6</hexacolor>
        <texturepng>/kewapp/textures/2.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/2.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/2.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="16">
        <techname>6T93</techname>
        <name>Turquoise</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>5DC1A5</hexacolor>
        <texturepng>/kewapp/textures/16.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/16.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/16.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="160">
        <techname>6T93</techname>
        <name>Turquoise</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>5DC1A5</hexacolor>
        <texturepng>/kewapp/textures/16.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/16.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/16.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="108">
        <techname>7TIF</techname>
        <name>Lagon</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>539D9B</hexacolor>
        <texturepng>/kewapp/textures/88.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/88.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/88.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="144">
        <techname>7TIF</techname>
        <name>Lagon</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>539D9B</hexacolor>
        <texturepng>/kewapp/textures/88.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/88.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/88.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="14">
        <techname>7T1D</techname>
        <name>Eau</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>069CCE</hexacolor>
        <texturepng>/kewapp/textures/14.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/14.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/14.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="126">
        <techname>7T1D</techname>
        <name>Eau</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>069CCE</hexacolor>
        <texturepng>/kewapp/textures/14.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/14.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/14.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="8">
        <techname>7T69</techname>
        <name>Ciel</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>6493C2</hexacolor>
        <texturepng>/kewapp/textures/8.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/8.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/8.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="159">
        <techname>7T69</techname>
        <name>Ciel</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>6493C2</hexacolor>
        <texturepng>/kewapp/textures/8.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/8.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/8.jpg</texturepixel>
        <opacity>0.8</opacity>
    </color>
    <color id="10">
        <techname>7T77</techname>
        <name>Arctic</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>71ABB7</hexacolor>
        <texturepng>/kewapp/textures/10.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/10.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/10.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="11">
        <techname>2T30</techname>
        <name>Sorbet</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>DDDC88</hexacolor>
        <texturepng>/kewapp/textures/11.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/11.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/11.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="127">
        <techname>7T77</techname>
        <name>Arctic</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>71ABB7</hexacolor>
        <texturepng>/kewapp/textures/10.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/10.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/10.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="146">
        <techname>2T30</techname>
        <name>Sorbet</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>DDDC88</hexacolor>
        <texturepng>/kewapp/textures/11.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/11.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/11.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="15">
        <techname>6T91</techname>
        <name>Citron Vert</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>C2D958</hexacolor>
        <texturepng>/kewapp/textures/15.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/15.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/15.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="20">
        <techname>6T92</techname>
        <name>Pomme</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>79DD11</hexacolor>
        <texturepng>/kewapp/textures/20.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/20.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/20.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="125">
        <techname>6T92</techname>
        <name>Pomme</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>79DD11</hexacolor>
        <texturepng>/kewapp/textures/20.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/20.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/20.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="147">
        <techname>6T91</techname>
        <name>Citron Vert</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>C2D958</hexacolor>
        <texturepng>/kewapp/textures/15.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/15.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/15.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="110">
        <techname>6T9A</techname>
        <name>Olive</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>9A9F38</hexacolor>
        <texturepng>/kewapp/textures/91.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/91.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/91.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="151">
        <techname>6T9A</techname>
        <name>Olive</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>9A9F38</hexacolor>
        <texturepng>/kewapp/textures/91.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/91.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/91.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="105">
        <techname>8T15</techname>
        <name>Prune</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>75225D</hexacolor>
        <texturepng>/kewapp/textures/86.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/86.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/86.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="156">
        <techname>8T15</techname>
        <name>Prune</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>75225D</hexacolor>
        <texturepng>/kewapp/textures/86.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/86.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/86.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="17">
        <techname>4T85</techname>
        <name>Cyclamen</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>DB4D99</hexacolor>
        <texturepng>/kewapp/textures/17.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/17.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/17.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="137">
        <techname>4T85</techname>
        <name>Cyclamen</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>DB4D99</hexacolor>
        <texturepng>/kewapp/textures/17.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/17.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/17.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="206">
        <techname>4T46</techname>
        <name>Rose Blush</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>E0AEA6</hexacolor>
        <texturepng>/kewapp/textures/164.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/164.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/164.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="208">
        <techname>4T46</techname>
        <name>Rose Blush</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>E0AEA6</hexacolor>
        <texturepng>/kewapp/textures/164.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/164.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/164.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="109">
        <techname>2T53</techname>
        <name>Mimosa</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFD24E</hexacolor>
        <texturepng>/kewapp/textures/92.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/92.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/92.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="142">
        <techname>2T53</techname>
        <name>Mimosa</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFD24E</hexacolor>
        <texturepng>/kewapp/textures/92.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/92.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/92.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="18">
        <techname>2T41</techname>
        <name>Orange</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>FEA000</hexacolor>
        <texturepng>/kewapp/textures/18.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/18.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/18.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="153">
        <techname>2T41</techname>
        <name>Orange</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>FEA000</hexacolor>
        <texturepng>/kewapp/textures/18.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/18.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/18.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="1">
        <techname>3T17</techname>
        <name>Mandarine</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>db5c0b</hexacolor>
        <texturepng>/kewapp/textures/1.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/1.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/1.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="148">
        <techname>3T17</techname>
        <name>Mandarine</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>db5c0b</hexacolor>
        <texturepng>/kewapp/textures/1.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/1.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/1.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="7">
        <techname>4T50</techname>
        <name>Chili</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>E91A24</hexacolor>
        <texturepng>/kewapp/textures/7.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/7.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/7.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="132">
        <techname>4T50</techname>
        <name>Chili</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>E91A24</hexacolor>
        <texturepng>/kewapp/textures/7.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/7.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/7.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="106">
        <techname>4T97</techname>
        <name>Framboise</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>D74652</hexacolor>
        <texturepng>/kewapp/textures/85.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/85.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/85.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="139">
        <techname>4T97</techname>
        <name>Framboise</name>
        <category>Acrylique translucide</category>
        <typecolor>pane</typecolor>
        <hexacolor>D74652</hexacolor>
        <texturepng>/kewapp/textures/85.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/85.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/85.jpg</texturepixel>
        <opacity>0.9</opacity>
    </color>
    <color id="104">
        <techname>1T41</techname>
        <name>Blanc Mat</name>
        <category>Acrylique opaque</category>
        <typecolor>pane</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/90.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/90.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/90.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="129">
        <techname>1T41</techname>
        <name>Blanc Mat</name>
        <category>Plateau verre + acrylique</category>
        <typecolor>plate</typecolor>
        <hexacolor>FFFFFF</hexacolor>
        <texturepng>/kewapp/textures/90.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/90.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/90.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="103">
        <techname>9221</techname>
        <name>Noir Mat</name>
        <category>Acrylique opaque</category>
        <typecolor>pane</typecolor>
        <hexacolor>222121</hexacolor>
        <texturepng>/kewapp/textures/89.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/89.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/89.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="149">
        <techname>9221</techname>
        <name>Noir Mat</name>
        <category>Acrylique opaque</category>
        <typecolor>pane</typecolor>
        <hexacolor>222121</hexacolor>
        <texturepng>/kewapp/textures/89.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/89.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/89.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="72">
        <techname>V3</techname>
        <name>Verre</name>
        <category>Autres</category>
        <typecolor>pane</typecolor>
        <hexacolor>D5DED9</hexacolor>
        <texturepng>/kewapp/textures/72.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/72.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/72.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="73">
        <techname>V3</techname>
        <name>Verre</name>
        <category>Autres</category>
        <typecolor>plate</typecolor>
        <hexacolor>D5DED9</hexacolor>
        <texturepng>/kewapp/textures/72.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/72.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/72.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="74">
        <techname>M3</techname>
        <name>Miroir</name>
        <category>Autres</category>
        <typecolor>pane</typecolor>
        <hexacolor>e2f7f0</hexacolor>
        <texturepng>/kewapp/textures/74.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/74.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/74.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="75">
        <techname>M3</techname>
        <name>Miroir</name>
        <category>Autres</category>
        <typecolor>plate</typecolor>
        <hexacolor>e2f7f0</hexacolor>
        <texturepng>/kewapp/textures/74.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/74.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/74.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="187">
        <techname>M3</techname>
        <name>Miroir</name>
        <category>Autres</category>
        <typecolor>plate</typecolor>
        <hexacolor>e2f7f0</hexacolor>
        <texturepng>/kewapp/textures/74.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/74.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/74.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="0">
        <techname>0</techname>
        <name>Vide</name>
        <category>Autres</category>
        <typecolor>0</typecolor>
        <hexacolor/>
        <texturepng/>
        <texturejpg/>
        <texturepixel/>
        <opacity>0</opacity>
    </color>
    <color id="101">
        <techname>V3</techname>
        <name>Verre</name>
        <category>Autres</category>
        <typecolor>pane</typecolor>
        <hexacolor>D5DED9</hexacolor>
        <texturepng>/kewapp/textures/72.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/72.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/72.jpg</texturepixel>
        <opacity>0.3</opacity>
    </color>
    <color id="186">
        <techname>M3</techname>
        <name>Miroir</name>
        <category>Autres</category>
        <typecolor>plate</typecolor>
        <hexacolor>e2f7f0</hexacolor>
        <texturepng>/kewapp/textures/74.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/74.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/74.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="192">
        <techname>DIBOND</techname>
        <name>Alu</name>
        <category>Autres</category>
        <typecolor>pane</typecolor>
        <hexacolor>99A099</hexacolor>
        <texturepng>/kewapp/textures/114.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/114.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/114.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
    <color id="193">
        <techname>DIBOND</techname>
        <name>Alu</name>
        <category>Autres</category>
        <typecolor>pane</typecolor>
        <hexacolor>99A099</hexacolor>
        <texturepng>/kewapp/textures/114.png</texturepng>
        <texturejpg>/kewapp/textures/jpg/114.jpg</texturejpg>
        <texturepixel>/kewapp/textures/pixel/114.jpg</texturepixel>
        <opacity>1.0</opacity>
    </color>
</colors>
`;
